import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 17,
	height: 14,
	viewBox: "0 0 17 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Arrow",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "Vector 140",
			d: "M7.24834 12L2.00195 7.00029L7.24834 2.00058",
			stroke: "#E5A500",
			strokeWidth: 1.5,
			strokeLinecap: "square"
		}), /* @__PURE__ */ _jsx("path", {
			id: "Vector 141",
			d: "M3.75508 6.99805L15.998 6.99805",
			stroke: "#E5A500",
			strokeWidth: 1.5,
			strokeLinecap: "square"
		})]
	})
});
export default SvgArrowLeft;
